<div class="ei-conflict-resolution">
    <!-- Header with bulk actions -->
    <div class="flex justify-content-between align-items-center mb-3">
        <div class="flex align-items-center gap-2">
            <span class="text-900 font-medium">Konflikte</span>
            <p-tag [severity]="pendingConflictsCount > 0 ? 'danger' : 'success'"
                   [value]="pendingConflictsCount + ' offen'"></p-tag>
        </div>
        @if (selectedConflicts.length > 0) {
            <div class="flex gap-2">
                <p-button label="Import akzeptieren ({{ selectedConflicts.length }})"
                          icon="fa-solid fa-download"
                          severity="success"
                          size="small"
                          (onClick)="bulkAcceptImport()"></p-button>
                <p-button label="System behalten ({{ selectedConflicts.length }})"
                          icon="fa-solid fa-database"
                          severity="secondary"
                          size="small"
                          (onClick)="bulkKeepSystem()"></p-button>
            </div>
        }
    </div>

    <!-- Conflicts Table -->
    @if (conflicts.length > 0) {
        <p-table [value]="conflicts"
                 [(selection)]="selectedConflicts"
                 dataKey="id"
                 styleClass="p-datatable-sm p-datatable-striped">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 3rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>Attribut</th>
                    <th>Import Wert</th>
                    <th>System Wert</th>
                    <th>Zeitstempel</th>
                    <th>Status</th>
                    <th style="width: 12rem">Aktionen</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-conflict>
                <tr [class.resolved]="conflict.resolutionStatus !== ResolutionStatus.PENDING">
                    <td>
                        <p-tableCheckbox [value]="conflict"
                                         [disabled]="conflict.resolutionStatus !== ResolutionStatus.PENDING">
                        </p-tableCheckbox>
                    </td>
                    <td>
                        <span class="font-medium">{{ conflict.attributeName }}</span>
                        @if (conflict.structureFieldDtoName) {
                            <br>
                            <span class="text-500 text-sm">{{ conflict.structureFieldDtoName }}</span>
                        }
                    </td>
                    <td>
                        <div class="import-value surface-100 p-2 border-round border-1 border-blue-200">
                            <i class="fa-solid fa-download text-blue-500 mr-2"></i>
                            <span class="text-blue-700">{{ conflict.importValue || '(leer)' }}</span>
                        </div>
                        @if (conflict.importValueDate) {
                            <div class="text-500 text-xs mt-1">
                                {{ conflict.importValueDate | date:'dd.MM.yyyy HH:mm' }}
                            </div>
                        }
                    </td>
                    <td>
                        <div class="system-value surface-100 p-2 border-round border-1 border-green-200">
                            <i class="fa-solid fa-database text-green-500 mr-2"></i>
                            <span class="text-green-700">{{ conflict.systemValue || '(leer)' }}</span>
                        </div>
                        @if (conflict.systemValueModifiedDate) {
                            <div class="text-500 text-xs mt-1">
                                {{ conflict.systemValueModifiedDate | date:'dd.MM.yyyy HH:mm' }}
                            </div>
                        }
                    </td>
                    <td>
                        @if (conflict.importValueDate && conflict.systemValueModifiedDate) {
                            @if (conflict.importValueDate > conflict.systemValueModifiedDate) {
                                <p-tag severity="info" value="Import neuer"></p-tag>
                            } @else {
                                <p-tag severity="success" value="System neuer"></p-tag>
                            }
                        } @else {
                            <span class="text-500">-</span>
                        }
                    </td>
                    <td>
                        <p-tag [severity]="getResolutionStatusSeverity(conflict.resolutionStatus)"
                               [value]="getResolutionStatusLabel(conflict.resolutionStatus)">
                        </p-tag>
                        @if (conflict.resolvedByUser) {
                            <div class="text-500 text-xs mt-1">
                                von {{ conflict.resolvedByUser }}
                            </div>
                        }
                    </td>
                    <td>
                        @if (conflict.resolutionStatus === ResolutionStatus.PENDING) {
                            <div class="flex gap-1">
                                <p-button icon="fa-solid fa-download"
                                          severity="success"
                                          size="small"
                                          pTooltip="Import akzeptieren"
                                          tooltipPosition="top"
                                          (onClick)="acceptImport(conflict)">
                                </p-button>
                                <p-button icon="fa-solid fa-database"
                                          severity="secondary"
                                          size="small"
                                          pTooltip="System behalten"
                                          tooltipPosition="top"
                                          (onClick)="keepSystem(conflict)">
                                </p-button>
                                <p-button icon="fa-solid fa-comment"
                                          severity="info"
                                          [outlined]="true"
                                          size="small"
                                          pTooltip="Mit Kommentar"
                                          tooltipPosition="top"
                                          (onClick)="openCommentDialog(conflict, ResolutionStatus.MERGED)">
                                </p-button>
                            </div>
                        } @else {
                            @if (conflict.resolutionComment) {
                                <i class="fa-solid fa-comment text-500"
                                   pTooltip="{{ conflict.resolutionComment }}"
                                   tooltipPosition="top"></i>
                            }
                        }
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7" class="text-center text-500 py-4">
                        Keine Konflikte vorhanden
                    </td>
                </tr>
            </ng-template>
        </p-table>
    } @else {
        <div class="text-center text-500 py-5">
            <i class="fa-solid fa-check-circle text-green-500 text-4xl mb-3"></i>
            <p>Keine Konflikte vorhanden</p>
        </div>
    }
</div>

<!-- Comment Dialog -->
<p-dialog header="Auflösung mit Kommentar"
          [(visible)]="showCommentDialog"
          [modal]="true"
          [style]="{width: '450px'}">
    <div class="flex flex-column gap-3">
        <div>
            <label for="resolution-comment" class="block text-900 font-medium mb-2">Kommentar</label>
            <textarea id="resolution-comment"
                      pInputTextarea
                      [(ngModel)]="resolutionComment"
                      rows="4"
                      class="w-full"
                      placeholder="Begründung für die Entscheidung..."></textarea>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Abbrechen"
                  severity="secondary"
                  (onClick)="cancelCommentDialog()"></p-button>
        <p-button label="Bestätigen"
                  severity="primary"
                  (onClick)="confirmResolutionWithComment()"></p-button>
    </ng-template>
</p-dialog>
